import { render } from "./PaypalProduct.vue?vue&type=template&id=2b9fc2a8"
import script from "./PaypalProduct.vue?vue&type=script&lang=js"
export * from "./PaypalProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__